import React from 'react'
import styled from 'styled-components'

const GREEN = '#00552e'
const MUTED = '#4b5563'

const SectionHeading = styled.div`
  margin: 30px 0 20px;

  h2 {
    margin: 0 0 4px;
    font-size: 23px;
  }

  p {
    margin: 0;
    color: ${MUTED};
  }
`

const AccessCards = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(280px, 1fr));
  gap: 20px;

  @media (max-width: 800px) {
    grid-template-columns: 1fr;
  }
`

const AccessCard = styled.div`
  padding: 26px;
  border: 1px solid #d8dde1;
  border-radius: 12px;

  h3 {
    margin: 0 0 10px;
    color: ${GREEN};
    font-size: 20px;
  }

  p {
    margin: 0 0 20px;
    line-height: 1.6;
    color: #30363d;
  }
`

const AccessButton = styled.a`
  display: inline-block;
  padding: 10px 16px;
  border-radius: 4px;
  background: ${GREEN};
  color: white;
  text-decoration: none;
  font-weight: 600;

  &:hover {
    opacity: 0.9;
  }
`

const IPNDownloads = () => (
    <>
        <SectionHeading>
            <h2>IPN Data Access</h2>
            <p>
                Request access to sequencing and phenotypic data available for the IPN cohort.
            </p>
        </SectionHeading>

        <AccessCards>
            <AccessCard>
                <h3>Sequencing Data</h3>

                <p>
                    Access to IPN sequencing data can be requested through the
                    Database of Genotypes and Phenotypes (dbGaP).
                </p>

                <AccessButton
                    href="PLACEHOLDER_DBGAP_LINK"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Request Sequencing Data Access →
                </AccessButton>
            </AccessCard>

            <AccessCard>
                <h3>Phenotypic Data</h3>

                <p>
                    Phenotypic and clinical data for the IPN cohort are available
                    through the SPARC Data Portal.
                </p>

                <AccessButton
                    href="PLACEHOLDER_SPARC_LINK"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Access Phenotypic Data →
                </AccessButton>
            </AccessCard>
        </AccessCards>
    </>
)

export default IPNDownloads